'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Device info class
 */
var DeviceInfo = function () {

    /**
     * Constructor
     * @constructor
     */
    function DeviceInfo() {
        (0, _classCallCheck3.default)(this, DeviceInfo);

        this.info = {
            os: 'ios',
            tablet: true,
            native: false,
            version: 0
        };
    }

    /**
     * Choose value if condition is true
     * @param {any} condition Any expression
     * @param {Function} valueFunc Function that returns value
     * @param {any} defaultValue Default value
     * @returns {*} New or default value
     */


    (0, _createClass3.default)(DeviceInfo, [{
        key: 'setIfTrue',
        value: function setIfTrue(condition, valueFunc, defaultValue) {
            return condition ? valueFunc() : defaultValue;
        }
    }, {
        key: 'setup',
        value: function setup(data) {
            this.info.os = this.setIfTrue(data.device_os, function () {
                return data.device_os.toLowerCase();
            }, this.info.os);
            this.info.tablet = this.setIfTrue(typeof data.is_tablet === 'boolean', function () {
                return data.is_tablet;
            }, this.info.tablet);
            this.info.native = this.setIfTrue(typeof data.is_native === 'boolean', function () {
                return data.is_native;
            }, this.info.native);
            this.info.version = this.setIfTrue(typeof data.os_version === 'number', function () {
                return data.os_version;
            }, this.info.version);
        }
    }, {
        key: 'osName',
        get: function get() {
            return this.info.os;
        }
    }, {
        key: 'osVersion',
        get: function get() {
            return this.info.version;
        }
    }, {
        key: 'isIOS',
        get: function get() {
            return this.info.os === 'ios';
        }
    }, {
        key: 'isAndroid',
        get: function get() {
            return this.info.os === 'android';
        }
    }]);
    return DeviceInfo;
}();

exports.default = DeviceInfo;
//# sourceMappingURL=DeviceInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-device-detection/dist/main/DeviceInfo.js
// module id = 516
// module chunks = 0